module.exports = __webpack_public_path__ + "assets/a7da9f7a6bc172784dddb1a7462d0257.png";